// Authentication configuration for Development mode only
export const authConfig = {
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

// Authentication types
export const AUTH_TYPE_DEVELOPMENT = "Development";

// Authentication type from environment or default
export const authType = import.meta.env.VITE_AUTH_TYPE || AUTH_TYPE_DEVELOPMENT;

// Debug logging
console.log("Environment VITE_AUTH_TYPE:", import.meta.env.VITE_AUTH_TYPE);
console.log("Final authType:", authType);
console.log("All environment variables:", import.meta.env);
